// extracted by mini-css-extract-plugin
export default {"emptyIcon":"Menu_emptyIcon__06yh2"};